<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template slot="item" slot-scope="props">
              <router-link
                :to="'/' + props.item.to"
                :disabled="props.item.disabled"
                v-bind:class="{
                  'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                    props.item.disabled,
                }"
                >{{ props.item.text }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="onSave"
          >
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="branchList"
                  label="Select Branch"
                  v-model="queryParams.branchId"
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Branch')"
                  :readonly="
                    depreciationStatus != 'DRAFT' || checkUserBranch()
                      ? true
                      : false
                  "
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="shopList"
                  v-model="queryParams.shopId"
                  label="Select shop"
                  item-text="code"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Shop')"
                  :readonly="
                    depreciationStatus != 'DRAFT' || checkUserShop()
                      ? true
                      : false
                  "
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-select
                  v-model="queryParams.departmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose Department..."
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Department')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="accountName"
                  label="Account Name"
                  type="text"
                  @click="showAccount"
                  v-model="queryParams.chartOfAccountName"
                  :rules="rules.required('Account name')"
                  :disabled="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="cost"
                  label="Cost"
                  v-model="queryParams.cost"
                  :rules="rules.depreciationCostRules"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="recoveryPeriod"
                  label="Recovery Period(Month)"
                  type="number"
                  v-model="queryParams.recoveryPeriod"
                  :rules="
                    queryParams.percentage > 0
                      ? rules.integerRules('Recovery period(month)')
                      : rules.recoveryPeriodRules
                  "
                  :disabled="
                    depreciationStatus != 'DRAFT' || queryParams.percentage > 0
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="percentage "
                  label="Percentage"
                  type="number"
                  v-model="queryParams.percentage"
                  :rules="
                    queryParams.recoveryPeriod > 0
                      ? rules.decimalRules('Percentage')
                      : rules.geraterThanzeroPercentageRules('Percentage')
                  "
                  :disabled="
                    depreciationStatus != 'DRAFT' ||
                    queryParams.recoveryPeriod > 0
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="depreciationMethodList"
                  label="Depreciation Method"
                  v-model="queryParams.depreciationMethod"
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Depreciation method')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="salvageValue"
                  label="Salvage Value"
                  type="number"
                  v-model="queryParams.salvageValue"
                  :disabled="depreciationStatus != 'DRAFT'"
                  :rules="rules.zeroAmountRules('Salvage value')"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="depreciationStatusList"
                  label="Depreciation Status"
                  v-model="queryParams.depreciationStatus"
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Depreciation status')"
                  :readonly="
                    depreciationStatus == 'CANCEL' ||
                    depreciationStatus == 'DISPOSAL'
                  "
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="depreciationTypeList"
                  label="Depreciation Type"
                  v-model="queryParams.depreciationType"
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Depreciation type')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="queryParams.startPeriodString"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  :disabled="depreciationStatus != 'DRAFT'"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="queryParams.startPeriodString"
                      label="Start Period"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="queryParams.startPeriodString"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.menu.save(queryParams.startPeriodString)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm3>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="depreciationStatus != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="Date"
                    type="text"
                    prepend-icon="event"
                    v-model="queryParams.date"
                  ></v-text-field>
                  <v-date-picker v-model="queryParams.date"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="assetName"
                  label="Asset Name"
                  type="text"
                  v-model="queryParams.assetName"
                  :rules="rules.required('Asset name')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="assetType"
                  label="Asset Type"
                  type="text"
                  v-model="queryParams.assetType"
                  :readonly="depreciationStatus != 'DRAFT'"
                  :rules="rules.required('Asset type')"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-autocomplete
                  label="Select Unit"
                  :items="unitList"
                  v-model="queryParams.unitId"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Unit')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="qty"
                  label="Qty"
                  type="number"
                  v-model="queryParams.qty"
                  :rules="rules.geraterThanZeroQtyRules('Qty')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="budgetAmount"
                  label="Budget Amount"
                  type="number"
                  v-model="queryParams.budgetAmount"
                  :rules="rules.zeroAmountRules('Budget amount')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="purchaseAmount"
                  label="Purchase Amount"
                  type="number"
                  v-model="queryParams.purchaseAmount"
                  :rules="rules.zeroAmountRules('Purchase amount')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="operationSettingList"
                  label="Operation Setting"
                  v-model="queryParams.operationSettingId"
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Operation setting')"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="description"
                  label="Description"
                  type="text"
                  v-model="queryParams.description"
                  :readonly="depreciationStatus != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-btn
                  outline
                  color="primary"
                  @click="onSearch"
                  :disabled="
                    depreciationStatus == 'CANCEL' ||
                    depreciationStatus == 'DISPOSAL'
                  "
                  >Calculate</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-flex xs12 ml-2 pt-2>
            <div style="float: left; padding-left: 11px">
              <p
                style="font-size: 13px; margin: 0px; font-weight: bold"
                id="counter"
              >
                Accumulated Depreciation :
                <v-chip>
                  <span>{{ finalAccDepreciationAmount | decFormat(2) }}</span>
                </v-chip>
              </p>
            </div>
          </v-flex>
          <br />
          <v-flex xs12 ml-2 pt-2 mt-2>
            <div style="float: left; padding-left: 11px">
              <p
                style="font-size: 13px; margin: 0px; font-weight: bold"
                id="counter"
              >
                Net Book Value :
                <v-chip>
                  <span v-if="finalNetBookValue >= 0">{{
                    finalNetBookValue | decFormat(2)
                  }}</span>
                  <span v-else class="red--text text--lighten-1">{{
                    finalNetBookValue | decFormat(2)
                  }}</span>
                </v-chip>
              </p>
            </div>
          </v-flex>
          <br />
          <v-flex xs12 ml-2 pt-2 mt-2>
            <div style="float: left; padding-left: 11px">
              <p
                style="font-size: 13px; margin: 0px; font-weight: bold"
                id="counter"
              >
                Total Count :
                <v-chip>
                  <span>{{ totalCount }}</span>
                </v-chip>
              </p>
            </div>
          </v-flex>
          <br />
          <v-flex xs12 ml-2 pt-4>
            <div style="float: left; padding-left: 11px">
              <h4 style="margin: 0px; color: blue" id="counter">
                Annual Depreciation Schedule
              </h4>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="width: 100%; height: 3px; background-color: blue"></div>
          </v-flex>
          <v-data-table
            :headers="headers"
            :items="assetDetailList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.endingDate | format-month }}</td>
              <td>{{ props.item.depreciationAmount | decFormat(2) }}</td>
              <td>
                {{ props.item.accumulatedDepreciationAmount | decFormat(2) }}
              </td>
              <td>
                <span v-if="props.item.netBookValue >= 0">{{
                  props.item.netBookValue | decFormat(2)
                }}</span>
                <span v-else class="red--text text--lighten-1">{{
                  props.item.netBookValue | decFormat(2)
                }}</span>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <v-flex sm12>
        <div class="text-xs-center">
          <v-btn
            color="error"
            @click="clear"
            :disabled="depreciationStatus != 'DRAFT'"
          >
            Reset
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            :loading="saveLoading"
            @click="onSave"
            :disabled="
              depreciationStatus == 'CANCEL' || depreciationStatus == 'DISPOSAL'
            "
          >
            Save
            <v-icon right>save</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- account list dialog -->
    <v-dialog v-model="showAccountListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3 pl-1>
              <v-text-field
                name="code"
                label="Account Code"
                type="text"
                v-model="accountParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-text-field
                name="accName"
                label="Account Name"
                type="text"
                v-model="accountParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                v-model="accountParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="searchAccount">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Shop List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeaders"
                :items="chartOfAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="accounttotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="accountpagination"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setAccount(props.item),
                        (showAccountListDialog = !showAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accountTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { assetService } from "../../services/asset-service";
import { shopService } from "../../services/shop-service";
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { Asset } from "../../models/model";
import { AssetFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { operationSettingService } from "../../services/operation-setting-service";
import { branchService } from "../../services/branch-service";
import { departmentService } from "../../services/department-service";
import { unitService } from "../../services/unit-service";

export default {
  name: "AssetDetail",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    saveLoading: false,
    showAccountListDialog: false,
    valid: true,
    clickCalculate: false,
    menu: false,
    breadcrumbs: [
      {
        text: "Asset",
        disabled: true,
      },
      {
        text: "Asset Detail",
        disabled: true,
      },
    ],
    asset: new Asset(),
    oldAsset: new Asset(),
    rules: new AssetFormRules(),
    accountParams: {
      code: "",
      accName: "",
      accountheadName: "",
      isParent: false,
    },
    accountpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    accountHeaders: [
      { text: "Code", align: "left", value: "code", sortable: false },
      { text: "Name", value: "accName", sortable: false },
      { text: "Account Type", value: "accountTypeName", sortable: false },
      { text: "Nature", value: "nature", sortable: false },
      { text: "Account Head", value: "accountName", sortable: false },
      { text: "Parent Code", value: "parentCode", sortable: false },
    ],
    headers: [
      {
        text: "Ending Date",
        align: "left",
        value: "endingDate",
        sortable: false,
      },
      { text: "Depreciation", value: "depreciationAmount", sortable: false },
      {
        text: "Total Depreciation",
        value: "accumulatedDepreciationAmount",
        sortable: false,
      },
      { text: "Net Book Value", value: "netBookValue", sortable: false },
    ],
    queryParams: {
      branchId: "",
      shopId: "",
      departmentId: "",
      chartOfAccountId: "",
      chartOfAccountName: "",
      cost: 0,
      recoveryPeriod: 0,
      percentage: 0,
      depreciationMethod: "STRAIGHT_LINE",
      salvageValue: 0,
      depreciationStatus: "",
      depreciationType: "MONTHLY",
      startPeriodString: new Date().toISOString().substring(0, 7),
      date: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      dateInMilliSeconds: "",
      assetName: "",
      assetType: "",
      unitId: "",
      qty: 0,
      budgetAmount: 0,
      purchaseAmount: 0,
      operationSettingId: "",
      description: "",
    },
    rowsPerPageItems: [25, 50, 100],
    depreciationMethodList: [
      { label: "Straight Line", value: "STRAIGHT_LINE" },
    ],
    depreciationTypeList: [{ label: "Monthly", value: "MONTHLY" }],
    depreciationStatusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    shopList: [],
    branchList: [],
    departmentList: [],
    unitList: [],
    chartOfAccountList: [],
    operationSettingList: [],
    assetDetailList: [],
    responseError: "",
    depreciationStatus: "DRAFT",
    finalAccDepreciationAmount: 0,
    finalNetBookValue: 0,
    totalCount: 0,
    accounttotalRows: 0,
  }),
  created() {
    this.queryParams.shopId = this.checkUserShop();
    this.queryParams.branchId = this.checkUserBranch();

    this.getAllShop();
    this.getActiveBranchList();
    this.getActiveDepartmentList();
    this.getActiveUnits();
    this.getOperationSettingList();

    //for deep linking
    const id = this.$route.params.id;
    if (id != "new") {
      this.getAssetDetail(id);
    }
  },
  watch: {
    accountpagination: {
      handler() {
        this.getChartOfAccountList();
      },
      deep: true,
    },
    queryParams: {
      handler() {
        this.clickCalculate = false;
      },
      deep: true,
    },
  },
  methods: {
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
      //   return "";
      // }
      return "";
    },
    checkUserShop() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveUnits() {
      unitService
        .getUnitsByStatus("ACTIVE")
        .then((res) => {
          this.unitList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOperationSettingList() {
      operationSettingService
        .getOperationSettingListByDepreciation()
        .then((res) => {
          this.operationSettingList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showAccount() {
      // Clean query params
      this.accountParams.code = "";
      this.accountParams.accName = "";
      this.accountParams.accountheadName = "";
      this.getChartOfAccountList().then(
        (this.showAccountListDialog = !this.showAccountListDialog)
      );
    },
    getChartOfAccountList() {
      this.showListLoading = true;
      let order = this.accountpagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.accountParams,
          this.accountpagination.page,
          this.accountpagination.rowsPerPage,
          this.accountpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.chartOfAccountList = res.data.chartOfAccountList;
            this.accounttotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    searchAccount() {
      this.accountParams.page = this.accountpagination.page;
      this.accountParams.size = this.accountpagination.rowsPerPage;
      this.getChartOfAccountList();
    },
    setAccount(account) {
      this.queryParams.chartOfAccountId = account.id;
      this.queryParams.chartOfAccountName = account.accName;
    },
    onSearch() {
      if (this.asset.id) {
        if (this.depreciationStatus == "DRAFT") {
          //delete all old asset id in draft status
          this.assetDetailList.forEach((detail) => {
            if (!this.asset.deleteAssetDetailIds) {
              this.asset.deleteAssetDetailIds = [];
            }
            this.asset.deleteAssetDetailIds.push(detail.id);
          });
        }
      }
      this.assetDetailList = [];
      this.totalCount = 0;
      this.finalAccDepreciationAmount = 0;
      this.finalNetBookValue = 0;
      if (this.$refs.form.validate()) {
        this.clickCalculate = true;
        this.convertQueryParamtoDepreciation();
        this.getAssetDetailList();
      }
    },
    convertQueryParamtoDepreciation() {
      this.asset.branchId = this.queryParams.branchId;
      this.asset.shopId = this.queryParams.shopId;
      this.asset.departmentId = this.queryParams.departmentId;
      this.asset.chartOfAccountId = this.queryParams.chartOfAccountId;
      this.asset.cost = this.queryParams.cost;
      this.asset.recoveryPeriod = this.queryParams.recoveryPeriod;
      this.asset.percentage = this.queryParams.percentage;
      this.asset.depreciationMethod = this.queryParams.depreciationMethod;
      this.asset.salvageValue = this.queryParams.salvageValue;
      this.asset.depreciationStatus = this.queryParams.depreciationStatus;
      this.asset.depreciationType = this.queryParams.depreciationType;
      this.asset.startPeriodString = this.queryParams.startPeriodString;
      this.asset.date = this.queryParams.date;
      this.asset.assetName = this.queryParams.assetName;
      this.asset.assetType = this.queryParams.assetType;
      this.asset.unitId = this.queryParams.unitId;
      this.asset.qty = this.queryParams.qty;
      this.asset.budgetAmount = this.queryParams.budgetAmount;
      this.asset.purchaseAmount = this.queryParams.purchaseAmount;
      this.asset.operationSettingId = this.queryParams.operationSettingId;
      this.asset.description = this.queryParams.description;
    },
    getAssetDetailList() {
      this.showListLoading = true;
      assetService
        .calculateAssetDetail(this.asset)
        .then((res) => {
          this.assetDetailList = res.data.asset.assetDetailList;
          this.finalAccDepreciationAmount =
            res.data.asset.finalAccDepreciationAmount;
          this.finalNetBookValue = res.data.asset.finalNetBookValue;
          this.totalCount = this.assetDetailList.length;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (this.assetDetailList.length != 0 && this.clickCalculate) {
          this.saveLoading = true;
          this.asset.dateInMilliSeconds = commonService.convertToMilliseconds(
            this.queryParams.date
          );
          this.asset.assetDetailList = this.assetDetailList;
          assetService
            .saveAsset(this.asset)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        } else {
          this.responseError = "Please Click the Calaculate Button First.";
        }
      }
    },
    getAssetDetail(id) {
      assetService
        .getAssetDetail(id)
        .then((res) => {
          this.asset = res.data;
          this.depreciationStatus = res.data.depreciationStatus;
          this.assetDetailList = this.asset.assetDetailList;
          this.totalCount = this.assetDetailList.length;
          if (this.asset.depreciationStatus == "CONFIRM") {
            this.depreciationStatusList = [
              { label: "CONFIRM", value: "CONFIRM" },
              { label: "DISPOSAL", value: "DISPOSAL" },
            ];
          } else if (this.asset.depreciationStatus == "DISPOSAL") {
            this.depreciationStatusList = [
              { label: "DISPOSAL", value: "DISPOSAL" },
            ];
          }
          this.finalAccDepreciationAmount =
            this.asset.finalAccDepreciationAmount;
          this.finalNetBookValue = this.asset.finalNetBookValue;
          this.convertDepreciationtoQueryParam();
          this.oldDepreciation = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    convertDepreciationtoQueryParam() {
      this.queryParams.branchId = this.asset.branchId;
      this.queryParams.shopId = this.asset.shopId;
      this.queryParams.departmentId = this.asset.departmentId;
      this.queryParams.chartOfAccountId = this.asset.chartOfAccountId;
      this.queryParams.chartOfAccountName = this.asset.chartOfAccountName;
      this.queryParams.cost = this.asset.cost;
      this.queryParams.recoveryPeriod = this.asset.recoveryPeriod;
      this.queryParams.percentage = this.asset.percentage;
      this.queryParams.depreciationMethod = this.asset.depreciationMethod;
      this.queryParams.salvageValue = this.asset.salvageValue;
      this.queryParams.depreciationStatus = this.asset.depreciationStatus;
      this.queryParams.depreciationType = this.asset.depreciationType;
      this.queryParams.startPeriodString = commonService.formatDate(
        this.asset.startPeriod.substr(0, 10),
        "YYYY-MM"
      );
      this.queryParams.date = commonService.millisecondToDate(
        this.asset.dateInMilliSeconds,
        "YYYY-MM-DD"
      );
      this.queryParams.assetName = this.asset.assetName;
      this.queryParams.assetType = this.asset.assetType;
      this.queryParams.unitId = this.asset.unitId;
      this.queryParams.qty = this.asset.qty;
      this.queryParams.budgetAmount = this.asset.budgetAmount;
      this.queryParams.purchaseAmount = this.asset.purchaseAmount;
      this.queryParams.operationSettingId = this.asset.operationSettingId;
      this.queryParams.description = this.asset.description;
    },
    goBack() {
      this.$router.go(-1);
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.asset.id) {
        this.asset = new Asset();
        this.assetDetailList = [];
        this.finalNetBookValue = 0;
        this.finalAccDepreciationAmount = 0;
        this.queryParams.branchId = "";
        this.queryParams.shopId = "";
        this.queryParams.departmentId = "";
        this.queryParams.chartOfAccountId = "";
        this.queryParams.chartOfAccountName = "";
        this.queryParams.cost = 0;
        this.queryParams.recoveryPeriod = 0;
        this.queryParams.percentage = 0;
        this.queryParams.depreciationMethod = "STRAIGHT_LINE";
        this.queryParams.salvageValue = 0;
        this.queryParams.depreciationStatus = "";
        this.queryParams.depreciationType = "";
        this.queryParams.startPeriodString = new Date()
          .toISOString()
          .substring(0, 7);
        this.queryParams.date = commonService.millisecondToDate(
          this.depreciation.dateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.queryParams.assetName = "";
        this.queryParams.assetType = "";
        this.queryParams.unitId = "";
        this.queryParams.qty = 0;
        this.queryParams.budgetAmount = 0;
        this.queryParams.purchaseAmount = 0;
        this.queryParams.operationSettingId = "";
        this.queryParams.description = "";
      } else {
        this.asset = JSON.parse(JSON.stringify(this.oldAsset));
        this.finalAccDepreciationAmount = this.asset.finalAccDepreciationAmount;
        this.finalNetBookValue = this.asset.finalNetBookValue;
        this.convertDepreciationtoQueryParam();
      }
    },
  },
};
</script>